<gl-base-modal (closeModal)="close(false)">
  <p>{{ 'payment_api_success' | translate }}</p>
</gl-base-modal>
